exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-center[data-v-3a10d3e1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.selWidth[data-v-3a10d3e1]{width:320px}.upload-demo[data-v-3a10d3e1]{display:inline-block !important;float:left}", ""]);

// exports
